<template>
    <div class='box'>
        <h4 class='title is-5 has-text-centered'>{{title}}</h4>
        <h5 class='subtitle is-6 has-text-centered'>{{completed}} of {{total}} items completed</h5>
        <ul>
            <li v-for="item in items" :key="item.id">
              <b-icon v-if="!item.completed" icon="checkbox-blank-circle-outline"></b-icon>
              <b-icon v-if="item.completed" class='has-text-success' icon="checkbox-marked-circle"></b-icon>

              {{item.text}}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'Checklist',
  props: ['title', 'items'],
  computed: {
    completed: function() {
      return this.items.filter(function(item) { return item.completed; }).length;
    },
    total: function() {
      return this.items.length;
    }
  },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Checklist.vue